import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch (e) {
      setUser(false);
      return false;
    }
  }, []);

  useEffect(() => {
    // Skip /me while returning from Google OAuth; AuthCallback establishes the session first.
    if (window.location.hash?.includes("session_id=")) return;
    refresh();
  }, [refresh]);

  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("pl_today");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, refresh, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);

export const nextPath = (user) => {
  const next = localStorage.getItem("pl_next");
  if (next) {
    localStorage.removeItem("pl_next");
    return next;
  }
  if (user?.household_id) return "/app";
  return user?.is_admin ? "/admin" : "/onboarding";
};
